import React from "react";
import banner from "../images/banner.jpg";
import { Link } from "react-router-dom";
import img from "../product images/hero image.jpg";
import shipped from "../logos/shipped.png";
import selled from "../logos/selled.jpg";
import promotions from "../logos/promotions.png";
import save_money from "../logos/save-money.png";
import order from "../logos/order.jpg";
import shirt1 from "../images/shirt1.jpg";
import banner1 from "../images/banner5.jpg";
class Home extends React.Component {
  render() {
    return (
      <div className="home">
        <img src={img} alt="" className="hero-image" />
        <div className="box">
          <h1>
            All Your favorite at <br /> one place
          </h1>
          <h2 className="offer-amount">Up To 30% Off</h2>
          <Link to="/upcoming" className="hero-btn btn">
            Shop New Arrivals
          </Link>
        </div>
        <section className="small-cards">
          <div className="free-shipping small-card">
            <img src={shipped} alt="" />
            <div className="shipping-text">
              <h3>Shipping Details</h3>
            </div>
          </div>
          <div className="online-order small-card">
            <img src={order} alt="" />
            <div className="order-text">
              <h3>Online Order</h3>
            </div>
          </div>
          <div className="save-money small-card">
            <img src={save_money} alt="" />
            <div className="save-money-text">
              <h3>Save Money</h3>
            </div>
          </div>
          <div className="promotions small-card">
            <img src={promotions} alt="" />
            <div className="promotions-text">
              <h3>Promotions</h3>
            </div>
          </div>
          <div className="happy-sell small-card">
            <img src={selled} alt="" />
            <div className="happy-sell-text">
              <h3>Happy Sell</h3>
            </div>
          </div>
        </section>
        <section className="display-cards">
          <div className="display-card">
            <h3>Create with strip lights</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_StripLighting_379x304_1X_en_US._SY304_CB418597476_.jpg"
              alt=""
            />
            <Link to="products">Shop now</Link>
          </div>
          <div className="display-card">
            <h3>For your Fitness Needs</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/September/DashboardCards/Fuji_Dash_Fitness_1X._SY304_CB639748186_.jpg"
              alt=""
            />
            <Link to="/products">Shop now</Link>
          </div>
          <div className="display-card">
            <h3>Shop Laptops & Tablets</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Laptops_379x304_1X_en_US._SY304_CB418608471_.jpg"
              alt=""
            />
            <Link to="/products">See more</Link>
          </div>
          <div className="display-card">
            <h3>Shop activity trackers and smartwatches</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/September/DashboardCards/Fuji_Dash_SmartWatch_1X._SY304_CB639922137_.jpg"
              alt=""
            />
            <Link to="/products">Shop now</Link>
          </div>
        </section>
        <section className="display-cards display-cards-2">
          <div className="display-card">
            <h3>Kindle E readers</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/September/DashboardCards/Fuji_Desktop_Dash_Kindle_1x._SY304_CB639752818_.jpg"
              alt=""
            />
            <Link to="products">Shop now</Link>
          </div>
          <div className="display-card">
            <h3>New Arrivals in TOY</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/September/DashboardCards/Fuji_Dash_Toys_1X._SY304_CB639759658_.jpg"
              alt=""
            />
            <Link to="/products">Shop now</Link>
          </div>
          <div className="display-card">
            <h3>Get Fit at Home</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/events/GFAH/GWDesktop_SingleImageCard_fitathome_1x._SY304_CB434924743_.jpg"
              alt=""
            />
            <Link to="/products">See more</Link>
          </div>
          <div className="display-card">
            <h3>Electronics</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Electronics_1x._SY304_CB432774322_.jpg"
              alt=""
            />
            <Link to="/products">Shop now</Link>
          </div>
        </section>
        <section className="display-cards display-cards-2">
          <div className="display-card">
            <h3>Easy Returns</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Returns_1x._SY304_CB432774714_.jpg"
              alt=""
            />
            <Link to="products">Shop now</Link>
          </div>
          <div className="display-card">
            <h3>Dresses</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2022/February/DashboardCards/Fuji_dash_dress_1X._SY304_CB626369146_.jpg"
              alt=""
            />
            <Link to="/products">Shop now</Link>
          </div>
          <div className="display-card">
            <h3>Shop Pet supplies</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/September/DashboardCards/Fuji_Dash_Pets_1X._SY304_CB639746743_.jpg"
              alt=""
            />
            <Link to="/products">See more</Link>
          </div>
          <div className="display-card">
            <h3>Deals in Tools and Home Improvement</h3>
            <img
              src="https://images-na.ssl-images-amazon.com/images/G/01/home/THILGMA/Holiday2022/Graphics/XCM_CUTTLE_1475305_2610205_379x304_1X_en_US._SY304_CB608600856_.jpg"
              alt=""
            />
            <Link to="/products">Shop now</Link>
          </div>
        </section>
        <section className="sm-banners">
          <div className="banner-1">
            <div className="banner-text">
              <span className="deals">Crazy Deals</span>
              <h2 className="buy-1">Buy 1 get 1 Free</h2>
              <br /> <br />
              <p className="classic">From Black Friday to Christmass</p>
              <button className="btn btn-learn-more">Learn More</button>
            </div>
            <img src={banner1} alt="" />
          </div>
          <div className="banner-2">
            <div className="banner-text">
              <span className="spring">Spring/Winter</span>
              <h2>Upcoming Seasons</h2>
              <p>The best classic dress is on sale at Amazon</p>
              <button className="btn btn-collection">Collection</button>
            </div>
            <img src={shirt1} alt="" />
          </div>
        </section>
        <section className="banner">
          <img src={banner} alt="" className="banner-img" />
          <div className="banner-text">
            <h1>Repair Services</h1>
            <h2>
              UP to <span className="off-70">70% OFF-</span> All Shirts and
              Accessories
            </h2>
            <button className="btn btn-banner">Explore More</button>
          </div>
        </section>
      </div>
    );
  }
}
export default Home;
